import PropTypes from "prop-types"
import { Flex, Tooltip } from "antd"
import { CheckCircleFilled, InfoCircleOutlined } from "@ant-design/icons"
import styles from "./index.module.css"

const WaiverStatus = ({ isWaiverAttached, totalGuestCount, signedWaiverCount }) => {
  if (!isWaiverAttached || !totalGuestCount) return null

  const isAllSigned = signedWaiverCount === totalGuestCount

  if (isAllSigned) {
    return (
      <Flex gap={4} align="center" className={styles.signed}>
        <CheckCircleFilled />
        <span>Signed</span>
      </Flex>
    )
  }

  const missingCount = totalGuestCount - signedWaiverCount

  return (
    <Flex gap={4} align="center" className={styles.missing}>
      <Tooltip title={`${signedWaiverCount} of ${totalGuestCount} waivers signed`}>
        <InfoCircleOutlined />
      </Tooltip>
      <span>
        {missingCount} missing
      </span>
    </Flex>
  )
}

WaiverStatus.propTypes = {
  isWaiverAttached: PropTypes.bool,
  totalGuestCount: PropTypes.number,
  signedWaiverCount: PropTypes.number
}

export default WaiverStatus
